<template>
  <div class="fnc-root">
    <transition-group name="fnc-slide" tag="div" class="fnc-list">
      <div
        v-for="n in notifications"
        :key="n.id"
        class="fnc-card"
      >
        <!-- 头部：图标 + 标题 + 关闭 -->
        <div class="fnc-header">
          <span class="fnc-icon">
            <i class="el-icon-warning-outline"></i>
          </span>
          <span class="fnc-title">
            {{ n.title }}
          </span>
          <button class="fnc-close" @click="onClose(n.id)">
            <i class="el-icon-close"></i>
          </button>
        </div>

        <!-- 错误信息 -->
        <div class="fnc-error">{{ n.error }}</div>

        <!-- 失败原因（failureReason） -->
        <!-- <div v-if="n.failureReason" class="fnc-failure-reason">{{ n.failureReason }}</div> -->

        <!-- 已自动重试提示（仅 storyboard / video 类型，且已达上限） -->
        <div v-if="n.maxAutoRetry > 0 && n.autoRetryCount >= n.maxAutoRetry" class="fnc-auto-hint">
          <i class="el-icon-warning-outline"></i>
          已自动重试 {{ n.autoRetryCount }} 次，不再自动重试
        </div>

        <!-- 操作 -->
        <div class="fnc-actions">
          <el-button
            v-if="n.retryFn"
            type="primary"
            size="mini"
            round
            :loading="n.loading"
            @click="onRetry(n)"
          >
            <i v-if="!n.loading" :class="n.retryIcon || 'el-icon-refresh-right'"></i>
            {{ n.loading ? (n.loadingText || '生成中...') : (n.retryLabel || '重新生成') }}
          </el-button>
          <el-button size="mini" round @click="onClose(n.id)">关闭</el-button>
        </div>
      </div>
    </transition-group>
    <transition name="fnc-bar-fade">
      <div v-if="notifications.length >= 1" class="fnc-dismiss-bar">
        <span class="fnc-dismiss-count">{{ notifications.length }} 条失败通知</span>
        <button class="fnc-dismiss-btn" @click="onCloseAll">
          <i class="el-icon-delete"></i> 一键关闭
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import failNotify from '@/utils/failNotify'

export default {
  name: 'FailNotifyContainer',
  computed: {
    notifications() {
      return failNotify.state.notifications
    },
  },
  methods: {
    onClose(id) {
      failNotify.remove(id)
    },

    onCloseAll() {
      failNotify.removeAll()
    },

    async onRetry(n) {
      if (n.loading || !n.retryFn) return
      failNotify.remove(n.id)
      try {
        await n.retryFn()
      } catch (e) {
        // 失败由业务侧继续通过 failNotify.add 添加（此时 _silentCounts 已清除，直接弹通知）
      }
    },
  },
}
</script>

<style scoped>
.fnc-root {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 3000;
  pointer-events: none;
}

.fnc-list {
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;
  align-items: flex-end;
}

.fnc-card {
  pointer-events: all;
  width: 320px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.14);
  border: 1px solid #EBEEF5;
  overflow: hidden;
  padding: 14px 16px 12px;
  box-sizing: border-box;
}

.fnc-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.fnc-icon {
  font-size: 16px;
  color: #E6A23C;
  flex-shrink: 0;
}

.fnc-title {
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fnc-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #C0C4CC;
  font-size: 14px;
  line-height: 1;
  padding: 2px;
  border-radius: 4px;
  transition: color 0.15s;
  flex-shrink: 0;
}
.fnc-close:hover { color: #909399; }

.fnc-error {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
  line-height: 1.5;
  word-break: break-all;
}

.fnc-failure-reason {
  font-size: 11px;
  color: #F56C6C;
  margin-bottom: 8px;
  line-height: 1.5;
  word-break: break-all;
  background: #FEF0F0;
  border-radius: 4px;
  padding: 4px 6px;
}

.fnc-auto-hint {
  font-size: 11px;
  color: #E6A23C;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.fnc-auto-hint i { font-size: 12px; flex-shrink: 0; }

.fnc-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.fnc-slide-enter-active {
  animation: fnc-slide-in 0.28s cubic-bezier(0.21, 1.02, 0.73, 1) forwards;
}
.fnc-slide-leave-active {
  animation: fnc-slide-out 0.22s ease-in forwards;
}

@keyframes fnc-slide-in {
  from { opacity: 0; transform: translateX(110%); }
  to   { opacity: 1; transform: translateX(0); }
}
@keyframes fnc-slide-out {
  from { opacity: 1; transform: translateX(0); }
  to   { opacity: 0; transform: translateX(110%); }
}

.fnc-slide-move { transition: transform 0.22s ease; }

.fnc-dismiss-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff2f0;
  border: 1px solid #ffb3b3;
  border-radius: 8px;
  padding: 7px 12px;
  margin-top: 8px;
  pointer-events: all;
  width: 320px;
  box-sizing: border-box;
}

.fnc-dismiss-count {
  font-size: 12px;
  color: #cf1322;
}

.fnc-dismiss-btn {
  background: none;
  border: 1px solid #ff4d4f;
  border-radius: 4px;
  cursor: pointer;
  color: #cf1322;
  font-size: 12px;
  padding: 2px 8px;
  transition: background 0.15s, color 0.15s;
}
.fnc-dismiss-btn:hover {
  background: #ff4d4f;
  color: #fff;
}

.fnc-bar-fade-enter-active { animation: fnc-slide-in 0.2s ease forwards; }
.fnc-bar-fade-leave-active { animation: fnc-slide-out 0.18s ease forwards; }
</style>
